export default {"src":"/_next/static/media/lines.48b0c69e.svg","height":367,"width":1824,"blurWidth":0,"blurHeight":0};